import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看全部",
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div>
        <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
          {icon && (
            <span className="w-7 h-7 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
              <i className={`${icon} text-base`}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {children}
        {moreTo && (
          <Link
            to={moreTo}
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        )}
      </div>
    </div>
  );
}